// libs
import React from 'react';
import PropTypes from 'prop-types';

// Component
import Text from './Text';
import TwoColumns from './TwoColumns';
import Gallery from './Gallery';
import Partners from './Partners';

// Props and Context
const propTypes = {
  flexibleContents: PropTypes.arrayOf(PropTypes.object).isRequired,
};
const defaultProps = {};
const contextType = {
  t: PropTypes.func,
};

function FlexibleContents(props) {
  const {
    flexibleContents,
  } = props;
  const flexibleContentComponent = (layout, flexibleContent, index) => {
    switch (layout) {
      case 'text':
        return <Text key={`${layout}_${index}`}>{flexibleContent.text}</Text>;
      case 'two_columns':
        return <TwoColumns key={`${layout}_${index}`} image={flexibleContent.image} text={flexibleContent.text} />;
      case 'gallery':
        return <Gallery key={`${layout}_${index}`} images={flexibleContent.images} />;
      case 'partners':
        return <Partners key={`${layout}_${index}`} partners={flexibleContent.partners} />;
      default:
        return null;
    }
  };
  return (
    <div className="flexible-content">
      {flexibleContents && flexibleContents.map((flexibleContent, index) =>
        flexibleContentComponent(flexibleContent.acf_fc_layout, flexibleContent, index),
      )}
    </div>
  );
}

FlexibleContents.propTypes = propTypes;
FlexibleContents.defaultProps = defaultProps;
FlexibleContents.contextTypes = contextType;

export default FlexibleContents;



// WEBPACK FOOTER //
// ./src/app/components/pages/default/flexibleContents/FlexibleContents.js